module.exports = __webpack_public_path__ + "static/media/event.2e6fa4d9.jpg";